module.exports = __webpack_public_path__ + "media/Strobeart_FAQ.281633bc.mp4";